import { schema } from 'normalizr';

export const bank = new schema.Entity(
  'banks',
  {},
  {
    idAttribute: item => parseInt(item.id, 10),
    processStrategy: item => ({
      id: parseInt(item.id, 10),
      financeId: parseInt(item.financeId, 10),
      slug: (item.slug || '').toLowerCase(),
      name: item.name,
      nameG: item.nameG,
      logo: item.logo32 || item.smallLogo,
    }),
  }
);

export const convertorBanks = [bank];
